"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimErrorReport = void 0;
require("./claim-error-report.less");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const React = require("react");
const mobx_1 = require("mobx");
const button_1 = require("client/components/material/button");
const modal_1 = require("client/components/modal");
const store_1 = require("client/modules/users/store");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const mobx_react_1 = require("mobx-react");
const store_2 = require("client/modules/reporting/store");
const number_formatter_1 = require("../claim-analytics/number-formatter");
const Launch_1 = require("@material-ui/icons/Launch");
const claim_error_header_1 = require("./components/claim-error-header");
// E-064.51
let ClaimErrorReport = class ClaimErrorReport extends React.Component {
    constructor(props) {
        super(props);
        this.showQueryManager = true;
        this.storeData = null;
        this.query = {
            start: new Date(),
            end: new Date()
        };
        this.CustomCellRendorIcon = (params) => {
            return (React.createElement("a", { href: `/claims/${params.value}`, target: "_blank", style: { cursor: "pointer" } },
                React.createElement(Launch_1.default, null)));
        };
        this.handleSubmit = async () => {
            var _a;
            this.showQueryManager = false;
            const result = await store_2.reportsStore.loadClaimErrorReport({
                query: this.query
            });
            this.storeData.rowData = (_a = result === null || result === void 0 ? void 0 : result.claimErrorData) !== null && _a !== void 0 ? _a : [];
        };
        this.renderQueryModal = () => {
            if (this.showQueryManager) {
                const cancelButton = (React.createElement(button_1.MaterialButton, { style: { marginLeft: "1em" }, onClick: () => (this.showQueryManager = false) }, "Cancel"));
                const submitButton = (React.createElement(button_1.MaterialButton, { primary: true, style: { marginLeft: "1em" }, onClick: this.handleSubmit }, "Submit"));
                const buttons = [cancelButton, submitButton];
                const model = (React.createElement(modal_1.Modal, { buttons: buttons, onCancel: () => (this.showQueryManager = false) },
                    React.createElement("div", { style: { display: "flex" } },
                        this.genDate("start"),
                        this.genDate("end"))));
                return model;
            }
        };
        this.genDate = (type) => {
            const title = type.replace(/\b\w/g, c => c.toUpperCase());
            const jsx = (React.createElement("div", { style: { padding: "1em" } },
                React.createElement("h3", null,
                    title,
                    " Date: "),
                React.createElement(date_picker_1.MaterialDatePicker, { label: `${title} Date`, required: true, value: this.query[type] || "", onChange: val => {
                        mobx_1.extendObservable(this.query, { [type]: val });
                    } }),
                React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                    React.createElement(button_1.MaterialButton, { primary: true, onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: new Date() });
                        }, style: { marginRight: "1em" } }, "Today"),
                    React.createElement(button_1.MaterialButton, { onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: null });
                        }, style: { marginRight: "1em" } }, "Clear"))));
            return jsx;
        };
        this.onButtonExport = () => {
            const params = {
                fileName: "Claim_Error_Report.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            columnDefs: [
                {
                    field: "orderId",
                    cellRendererFramework: this.CustomCellRendorIcon,
                    headerName: "Link To Order",
                    filter: false,
                    width: 150
                },
                {
                    field: "date",
                    filter: "agDateColumnFilter",
                    valueFormatter: (params) => {
                        const dateValue = new Date(params.value); // Assuming params.value is a date string or timestamp
                        return this.formatDateToMMDDYYYY(dateValue);
                    },
                    headerName: "Date",
                    width: 170
                },
                {
                    field: "orderId",
                    filter: "agTextColumnFilter",
                    headerName: "Claim Number",
                    width: 130
                },
                {
                    field: "rxId",
                    filter: "agTextColumnFilter",
                    headerName: "Rx #",
                    width: 130
                },
                {
                    field: "rejectCode",
                    filter: "agTextColumnFilter",
                    headerName: "Reject Code",
                    width: 110
                },
                {
                    field: "resolved",
                    filter: "agTextColumnFilter",
                    headerName: "Resolved",
                    width: 110
                },
                {
                    field: "resolution",
                    filter: "agTextColumnFilter",
                    headerName: "Resolution",
                    width: 170
                },
                {
                    field: "autoAttempts",
                    filter: "agTextColumnFilter",
                    headerName: "Auto Attempts",
                    width: 100
                },
                {
                    field: "errorType",
                    filter: "agTextColumnFilter",
                    headerName: "Error Type",
                    width: 120
                }
            ],
            defaultColDef: {
                comparator: (a, b) => typeof a === "string"
                    ? a.localeCompare(b)
                    : a > b
                        ? 1
                        : a < b
                            ? -1
                            : 0,
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            },
            multiSortKey: "ctrl",
            rowData: []
        };
    }
    formatDateToMMDDYYYY(date) {
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    render() {
        const buttons = [
            React.createElement("button", { onClick: () => {
                    this.showQueryManager = true;
                }, style: { marginLeft: "2em" }, type: "button" }, "Manage Query")
        ];
        const header = (React.createElement(claim_error_header_1.ClaimErrorHeader, { buttons: buttons, title: "Claim Error Log" }));
        const agGrid = (React.createElement("div", { className: "ag-theme-balham", style: {
                height: "85%",
                width: "100%"
            } },
            React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
            React.createElement(ag_grid_react_1.AgGridReact, { animateRows: true, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, floatingFilter: this.storeData.floatingFilter, frameworkComponents: this.storeData.frameworkComponents, groupMultiAutoColumn: true, multiSortKey: this.storeData.multiSortKey, onGridReady: params => {
                    this.storeData.gridApi = params.api;
                }, rowData: [...this.storeData.rowData], sideBar: true, suppressExcelExport: true, suppressRowClickSelection: true })));
        return (React.createElement(React.Fragment, null, store_1.usersStore.permissions.ReadClaimErrorReport ? (React.createElement(React.Fragment, null,
            header,
            React.createElement("br", null),
            agGrid,
            this.renderQueryModal())) : (store_1.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], ClaimErrorReport.prototype, "showQueryManager", void 0);
__decorate([
    mobx_1.observable
], ClaimErrorReport.prototype, "storeData", void 0);
__decorate([
    mobx_1.observable
], ClaimErrorReport.prototype, "query", void 0);
ClaimErrorReport = __decorate([
    mobx_react_1.observer
], ClaimErrorReport);
exports.ClaimErrorReport = ClaimErrorReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-error-report/cliam-error-report.tsx
// module id = 3993
// module chunks = 0